import React, { useEffect, useState } from "react";
import Modal from 'react-responsive-modal';
import { CommonUtilities } from "../../commonUtils";
import Drawer from 'react-modern-drawer';
import trackServices from "../MetaData/Tracks/trackServices";
import songServices from "../MetaData/Songs/songServices";
import ReleaseService from "../MetaData/Release/ReleaseService";
import commonServices from "./commonServices";

export default function ViewContractAsset (param: any){

    const [openFirst, setOpenFirst] = React.useState(false);
    const [totalRowsAll, setTotalRowsAll] = useState(1);
    const [isOpen, setIsOpen] = React.useState(false);
    const [totalRows, setTotalRows] = useState(1);
    const [SongActive, setSongActive] = useState(1);
    const [ViewAsset, initViewAsset] = useState<any[]>([]);
    //const [contractTrackAsset, initcontractTrackAsset] = useState<any[]>([]);
    var dataLink = "pageSize=10&pageNumber=1"; 

    const toggleDrawer = () => { 
        setIsOpen(!isOpen) 
    }

    let Data:any =  {
        pageSize : 10,
        pageNumber : 1 ,
        assetType : ''
    }

    const getApis =()=> {

        //ViewContractAsset-Track
        if(param.type === "track"){
            Data.assetType = param.type
            Data.isrc = param.data.code
            commonServices.listMyassetContracts(Data)
            //trackServices.listMyassetContractsTrack(Data)
            .then((res:any) => {                
                setTotalRows(res.totalRows)
                initViewAsset(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));                
                }
            )
        }

        //ViewContractAsset-Song
        if(param.type === "song"){
            Data.assetType = param.type
            Data.songCode = param.data.code
            commonServices.listMyassetContracts(Data)
           //songServices.listMyassetContractsSong(Data)
            .then((res:any) => {                
                setTotalRows(res.totalRows)
                initViewAsset(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));                
                }
            )/**/
        }

        //ViewContractAsset-Release
        if(param.type === "release"){
            Data.assetType = param.type
            Data.releaseCode = param.data.code
            commonServices.listMyassetContracts(Data)
            //ReleaseService.listMyassetContractsRelease(Data)
            .then((res:any) => {                
                setTotalRows(res.totalRows)
                initViewAsset(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));                
                }
            )
        }
    }

    const tabChange =(e:any)=> {

        if(e.target.innerHTML === "SongTrack"){
            Data.assetType = "SongTrack";
            Data.songCode = param.data.code;
            commonServices.listMyassetContracts(Data)
            .then((res:any) => {                
                setTotalRows(res.totalRows)
                initViewAsset(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));                
                }
            )
        }else{
            getApis();
        }

    }

    const exportDate = () => {

        if(param.type === "track"){
            Data.assetType = param.type;      
            Data.isrc = param.data.code
            Data.export = 1;
            commonServices.export(Data);
        }
    }
    return(
        <>
           <button className="icon-btn info pull-right" 
               onClick={() => {setIsOpen(!isOpen) ; getApis() }}>
               <i className="icon-price-list"></i>
           </button>

           <Drawer open={isOpen}
               onClose={toggleDrawer}
               direction='right'
               className='react-drawer'
               size={800}>   

                <div className="ws-12 p1 box-header">
                    <h2 className="mlxl pull-left text-center">
                        List of Contract Assets for {param.data.code} <strong><i></i></strong> - ({totalRows}) records found</h2> 
                    <i className="icon-close pull-right pLarge" onClick={() => setIsOpen(!isOpen) }></i>
                    <a className="icon-btn primary btn-sm pull-right mtl hide" onClick={() =>exportDate()}><i className="icon-download1"></i> Export</a>      
                </div>

                <div className="ws-12 ptl pll">

                    {     
                        (() => {
                            if(param.type === "song"){
                                return (
                                    <div className="p1">
                                        <ul className="nav nav-tabs mbl">
                                            <li className={SongActive === 1? "btn active" : "btn"} onClick={(e:any)=>{setSongActive(1); tabChange(e)}}>
                                                Song
                                            </li>
                                            <li className={SongActive === 2? "btn active" : "btn"} onClick={(e:any)=>{setSongActive(2); tabChange(e)}}>
                                                SongTrack
                                            </li>
                                        </ul>
                                    </div>
                                );
                            }

                        })()
                    }
                </div>
       
                <div className="box-content">                    
                    <table className="newTable">
                        <thead>
                               <tr className={totalRows>0? "" :"hide"}>
                                   <th>ContractRefNum</th>
                                   <th>Contract Title</th>   

                                   {(()=>{
                                        if(param.type === "release"){
                                            return (
                                                <><th>Track Title</th>
                                                <th>ISRC</th></>
                                            );
                                        }
                                   })()}                                 
                                   <th>Territory Code</th>
                                   <th>Format</th>
                                   <th>Main Rate</th>
                               </tr>
                        </thead>

                        <tbody>
                            { (()=> {
                                if(totalRows && totalRows>0){
                                    return(
                                        ViewAsset.map( post => {
                                            return ( 
                                                   <tr>
                                                       <td>{post.contractRefNum}</td>
                                                       <td>{post.contractTitle}</td>
                                                       {(()=>{
                                                            if(param.type === "release"){
                                                                return (
                                                                    <><td>{post.trackTitle}</td>
                                                                     <td>{post.iSRC}</td></>
                                                                );
                                                            }
                                                        })()}  
                                                       <td>{post.territoryCode}</td>
                                                       <td>{post.formatId}</td>
                                                       <td>{post.mainRate}</td>
                                                   </tr>
                                               );
                                           })
                                    )}else { 
                                        return (
                                            <div className="ws-12">
                                                <h2 className="alert alert-success ws-12 text-center">No contracts assets to display.</h2>
                                            </div>
                                        )
                                    }
                                       
                                })()          
                            }
                        </tbody>

                    </table>                  

                </div>               

            </Drawer>
       </>
   )
}

